import { apiFetch } from './client';
import type { LegalContent } from '../types/dtos';

/** Fetches a public legal page by slug + language. Anonymous; backend serves sanitized HTML. */
export async function getLegalContent(slug: string, lang: string): Promise<LegalContent> {
  return apiFetch<LegalContent>(`/v1/legal/${encodeURIComponent(slug)}?lang=${encodeURIComponent(lang)}`);
}
